import {
  TutorialActionDispatchContext,
  TutorialContext,
  useTutorialReducer,
} from "./useTutorialState";

interface TutorialProviderProps {
  storageKey?: string;
  children: React.ReactNode;
}

export default function TutorialProvider({ children }: TutorialProviderProps) {
  const [gameState, dispatch] = useTutorialReducer();

  return (
    <TutorialContext.Provider
      value={{
        ...gameState,
      }}
    >
      <TutorialActionDispatchContext.Provider value={dispatch}>
        {children}
      </TutorialActionDispatchContext.Provider>
    </TutorialContext.Provider>
  );
}
